<template>
  <div class="dataview" v-loading="loading">
    <!-- <el-row>
            <el-col :span="9">
                <flex-box title="上次登录时间：">
                    {{ lastLoginTime || '2014-12-05 22:22:22' }}
                </flex-box>
            </el-col>
    </el-row>-->
  </div>
</template>
<script>
import { transformDate } from '@/utils/handle'
export default {
  data () {
    return {
      loading: false,
      lastLoginTime: JSON.parse(localStorage.getItem('currentUser'))
        .lastLoginTime,
    }
  },
  mounted () {
    this.$router.push({ path: '/my-workbench/MyWorkbench' }) // 跳转我的工作台
  },
  computed: {
    yesterday: function () {
      let time = new Date()
      time = time.getTime() - 1000 * 60 * 60 * 24
      console.log(time)
      return transformDate('yyyy/MM/dd', time)
    }
  }
}
</script>
<style lang="scss" scoped>
.dataview {
  .title {
    font-size: 14px;
    margin-bottom: 10px;
    color: #333;
    font-weight: bold;
    padding-left: 10px;

    border-left: 3px solid #409eff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Dataview.vue